module.exports = __webpack_public_path__ + "static/media/21ECLAC39.0ab137b7.jpg";